import { logo } from "assets";
import React, { useState } from "react";
import { HiMenuAlt4, HiX } from "react-icons/hi";
import { motion } from "framer-motion";

import "./Navbar.scss";
import Lang from "./Lang";

const Navbar = () => {
  const NavData = ["home", "about", "work", "skills", "testimonial", "contact"];
  const [toggle, setToggle] = useState(false);

  return (
    <nav className="app__navbar">
      <div className="app__navbar-logo">
        <a href="/">
          <img src={logo} alt="logo" />
        </a>
      </div>
      <ul className="app__navbar-link">
        {NavData.map((item, i) => (
          <li key={item + i} className="app__flex p-text">
            <div />
            <a href={`#${item}`}>{item}</a>
          </li>
        ))}
      </ul>
      <Lang />
      <div className="app__navbar-menu">
        <HiMenuAlt4 onClick={() => setToggle(true)} />

        {toggle && (
          <motion.div
            whileInView={{ x: [300, 0] }}
            transition={{ duration: 0.85, ease: "easeOut" }}
          >
            <HiX onClick={() => setToggle(false)} />
            <ul className="app__navbar-link">
              {NavData.map((item, i) => (
                <li
                  key={i}
                  className="app__flex p-text"
                  onClick={() => setToggle(false)}
                >
                  <a href={`#${item}`}>{item}</a>
                </li>
              ))}
            </ul>
            <Lang />
          </motion.div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
